module.exports = __webpack_public_path__ + "assets/media/2.535cfbe7.wav";